import axios from 'axios'
import Browser from 'util/browser'
import { bridge } from 'util/appBridge'
import eventcenter from '@/util/eventcenter'
import { getDevicesId } from '@/util/manageDeviceId'

const xhr = axios.create({
  baseURL: '/',
  timeout: 1000 * 5
})

// 获取APP系统参数
/**
 * vc=16844293
uid=5198B501-E506-43DD-86F2-4A8BAADEA930
net=Wifi
den=3
mod=iPhone11,6
vn=1.1.6
os=i
app=qimeng-app
ovc=13.5.1
man=Apple
dis=896_414
tn=10002i
apn=460-01
ovn=iOS
aid=com.vipkid.nezha&goodsId=11841158825812242
 */
xhr.interceptors.request.use((config) => {
  console.log('[res]', Browser.vkhybrid, navigator.userAgent, Browser.getAppVersion(), Browser.compareVersion(Browser.getAppVersion(), '1.1.8'))
  const defaultParams = {
    app: Browser.vkhybrid ? (Browser.android ? 'qimeng-android' : 'qimeng-app') : 'qimeng-h5',
    os: Browser.android ? 'a' : 'i',
    tn: '',
    uid: '',
    vn: Browser.getAppVersion(),
    vc: '',
    apn: '',
    ovn: '',
    ovc: ''
  }
  // 1.1.8一下版本不使用getCommonParams这个桥
  if (!Browser.vkhybrid || Browser.compareVersion(Browser.getAppVersion(), '1.1.8') === 'lt') {
    config.params = Object.assign(defaultParams, config.params || {})
    return config
  }

  return new Promise((resolve, reject) => {
    bridge.appExcute({
      namespace: 'nz_apply/getCommonParams'
    }, { timeout: 200 })
      .then((res) => {
        const params = res.data
        console.warn('[res]', res, params)
        config.params = Object.assign(params, config.params || {})
        resolve(config)
      }).catch((err) => {
        console.error('[globalparams]', err)
        resolve(config)
      })
  })
}, (error) => {
  return Promise.reject(error)
})

// 添加header信息
xhr.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  console.log('[res]', Browser.vkhybrid, navigator.userAgent, Browser.getAppVersion())
  if (Browser.vkhybrid) {
    return new Promise((resolve, reject) => {
      bridge.appExcute({
        namespace: 'nz_apply/acceptaccount'
      }).then((account) => {
        console.log('[account]', account)

        // 种植localstarge Android创建新的webview的时候localstorage貌似没有保持
        for (const i in account.data) {
          localStorage.setItem(i, account.data[i])
        }

        config.headers.Authorization = `Bearer ${account.data.token}`
        config.headers.devicesId = `${account.data.devicesId}`
        resolve(config)
      }).catch((err) => {
        console.error('[account]', err)
        reject(err)
      })
    })
  } else {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    config.headers.devicesId = getDevicesId()
    return config
  }
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

function codeInterceptor(res) {
  switch (res.data.code) {
    case 200:
      break
    case 403:
      if (Browser.vkhybrid) {
        bridge.appExcute({
          namespace: 'nz_apply/login'
        }).then((result) => {
          if (result.data.isSuccess === true || result.data.isSuccess === 1) {
            location.reload(true)
          } else {

          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        // TODO: web login
      }

      break
    default:
      var noIntercept = res.config.noIntercept
      if (noIntercept !== true) {
        if (Object.prototype.toString.call(noIntercept).toLowerCase() !== '[object array]') {
          noIntercept = [noIntercept]
        }

        if (!noIntercept.some((exCode) => {
          return parseInt(res.data.code) === parseInt(exCode)
        })) {
          eventcenter.emit('xhr_req_toast', res.data.message || '请稍后再试')
        }
      }
  }
}

xhr.interceptors.response.use(function (response) {
  codeInterceptor(response)
  // 对响应数据做点什么
  return response.data
}, function (error) {
  codeInterceptor(error.response)
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default xhr
